/**
 * Progress of an analysis (or of one of its vehicle analyses), as returned by the /v1/web-app API.
 * Replaces AnalysisStatusEnum, which the back marks as deprecated:
 *  - ACQUISITION        <- STARTED
 *  - TERMINAL           <- UPLOADED / AI_READY / FINISHED
 *  - ABORTED            <- ABORTED
 * PENDING_ANNOTATION
 */
export enum AnalysisStage {
  ACQUISITION = 'ACQUISITION',
  PENDING_ANNOTATION = 'PENDING_ANNOTATION',
  TERMINAL = 'TERMINAL',
  ABORTED = 'ABORTED'
}
